/**
 * Global components
 * By Juan Magos <jmagossanche@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB Solutions Headers
 */
import React, { useRef } from 'react';
import { SVBTypography, SVBCard, SVBBreadCrumb } from '@svb/svb-react-components';
//import { Utils } from '@svb/api-content-component';
import { getIntegrationChecklist } from './helper';
import { slugCreator } from '../../core/useStore';
/**
 *
 * @param title: Title for the solution header
 * @param description: Description text
 * @param backgroundImage: Right side image for the solutions header
 * @param headerIcon: Icon below title text
 * @param widgets: Array of strings to show the current navigation path
 * @returns SVB Solutions Headers as per SVB Design
 */
const SVBChecklistHeader = (props) => {
  let checklistJsonResponse = getIntegrationChecklist(props?.contentUrl, 'hero-widgets.json');
  let checklistJson = checklistJsonResponse?.response;
  const title = checklistJson?.title ?? '';
  const description = checklistJson?.description ?? '';
  let headerIcon;
  try {
    headerIcon =
      props?.headerIcon && require('@svb/svbbranding/dist/assets/icons' + props.headerIcon);
  } catch (error) {
    console.log(`Error: Cannot find icon ${props.headerIcon}`);
    //fallback empty icon
    headerIcon =
      "data:image/svg+xml;charset=utf8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%3E%3C/svg%3E";
  }
  // const headerIcon =
  //   props?.headerIcon !== ''
  //     ? require('@svb/svbbranding/dist/assets/icons' + props.headerIcon)
  //     : '';
  const backgroundImage = checklistJson?.background ?? '';
  const widgets = checklistJson?.widgets;
  const windowWidth = useRef(window?.innerWidth);

  const cardOptions = {
    cardClickable: false,
  };

  return (
    <section
      className='svb-checklist-header-container'
      // @todo move positonX style to branding
      style={{
        backgroundPositionX: '98%',
        backgroundImage: windowWidth?.current < 770 ? '' : `url("${backgroundImage}")`,
      }}
    >
      <div className='pt-4'>
        <SVBBreadCrumb
          breadCrumbs={[
            { breadCrumb: 'Home', link: '/', dataTestId: 'breadcrumb-integration-checklist-home' },
            {
              breadCrumb: `${title}`,
              link: '#',
              dataTestId: slugCreator(`breadcrumb-integration-checklist-${title}`),
            },
          ]}
          extraClasses
        ></SVBBreadCrumb>
      </div>
      <div className='container svb-container-fixed pb-5 px-4'>
        <div className='col-md-4 pt-5'>
          <img src={headerIcon} alt={title} />
        </div>
        <h1 className='heading-xlarge mt-4'>{title}</h1>
        <div>
          <div className='col-md-9 mt-4 mb-4'>
            <SVBTypography type='heading-small'>{description}</SVBTypography>
          </div>
          <div className='cards justify-content-between align-items-center'>
            <div className='d-flex widgets-direction'>
              {widgets?.map((widget, index) => {
                return [
                  <React.Fragment key={index}>
                    <div className='w-100'>
                      <SVBCard
                        cardIcon={widget?.cardIcon}
                        title={widget?.feature_name}
                        description={widget?.feature_description}
                        cardOptions={cardOptions}
                        extraClasses={`h-100 pe-2 svb-checklist-card-container col flex-row flex-sm-row flex-md-column flex-xl-row ${widget?.cardBorder}`}
                        explicitImgWidth={60}
                        explicitImgHeight={60}
                        lazyLoading={true}
                      ></SVBCard>
                    </div>
                  </React.Fragment>,
                  index !== widgets.length - 1 && (
                    <div className='mx-auto my-auto' key={index + 1000}>
                      {windowWidth?.current < 770 && (
                        <i
                          className='px-3 mx-auto my-auto fa-solid fa-chevron-down bi-chevron-down svb-checklist-card-chevron my-2'
                          size='2xl'
                        />
                      )}
                      {windowWidth?.current > 770 && (
                        <i className='px-3 mx-auto my-auto fa-solid fa-chevron-right bi-chevron-right svb-checklist-card-chevron mx-5' />
                      )}
                    </div>
                  ),
                ];
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SVBChecklistHeader;
